import {
  Typo3SectionSpotSanityAccomodation,
  Typo3SectionSpotSanityCulture,
  Typo3SectionSpotSanityEatDrink,
  Typo3SectionSpotSanityEventList,
  Typo3SectionSpotSanityFreetime,
  Typo3SectionSpotSanityNature,
  Typo3SectionSpotSanityService,
  Typo3SectionSpotSanityShopping,
  Typo3SectionSpotSanitySport,
  Typo3SectionSpotSanitySportServices
} from '@/types'
import { RatingStarsProps } from '@/ui/components/RatingStars/RatingStars'
import { SectionHero } from '@/ui/Sections'
import { memo } from 'react'
interface Props extends React.HTMLAttributes<HTMLDivElement> {
  data:
    | Typo3SectionSpotSanityNature
    | Typo3SectionSpotSanitySport
    | Typo3SectionSpotSanityEatDrink
    | Typo3SectionSpotSanityAccomodation
    | Typo3SectionSpotSanityCulture
    | Typo3SectionSpotSanityService
    | Typo3SectionSpotSanityShopping
    | Typo3SectionSpotSanityFreetime
    | Typo3SectionSpotSanitySportServices
    | Typo3SectionSpotSanityEventList
  showImages?: boolean
  showText?: boolean
  stars?: RatingStarsProps['stars']
}

const SpotSanityDetailHero = ({
  data,
  showText = true,
  stars,
  ...props
}: Props) => {
  const item = data?.content?.item
  const content = data?.content

  const uriBack = content?.item?.uriBack || content?.uriBack

  return (
    <SectionHero
      pageData={{
        id: data?.id ?? 0,
        slug: uriBack?.href ?? '',
        meta: {
          title: content?.item?.title ?? '',
          description: content?.item?.leadText ?? ''
        },
        content: [{ type: data?.type }],
        i18n: [],
        breadcrumbs: uriBack
          ? [
              {
                title: uriBack?.title,
                link: uriBack?.href
              }
            ]
          : undefined,
        appearance: { layout: 'page' }
      }}
      data={{
        appearance: {
          layout: 'default'
        },
        title: content?.title,
        hasText: item?.leadText ? true : false,
        stars: stars,
        text: showText ? content?.item?.leadText : undefined
      }}
      {...props}
    />
  )
}

export default memo(SpotSanityDetailHero)
